export const REQUEST_PACKAGES = 'OVERVIEW_PAGE/REQUEST_PACKAGES';
export const REQUEST_PACKAGES_ERROR = 'OVERVIEW_PAGE/REQUEST_PACKAGES_ERROR';
export const SET_PACKAGES = 'OVERVIEW_PAGE/SET_PACKAGES';

export const REQUEST_DEVICES = 'OVERVIEW_PAGE/REQUEST_DEVICES';
export const REQUEST_DEVICES_ERROR = 'OVERVIEW_PAGE/REQUEST_DEVICES_ERROR';
export const SET_DEVICES = 'OVERVIEW_PAGE/SET_DEVICES';
